// Footer.jsx
import React from 'react';

const Footer = () => (
  <footer style={footerStyle}>
    <p>&copy; {new Date().getFullYear()} Currentjobs.co.ke. All rights reserved.</p>
    <p><a href="/about" style={link}>About</a> | <a href="/privacy" style={link}>Privacy Policy</a> | <a href="/terms" style={link}>Terms of Use</a> Contacts info@currentjobs.co.ke</p>
  </footer>
);

const footerStyle = {

  backgroundColor: '#004d40',
  color: '#fff',
  textAlign: 'center',
  padding: '15px'
};

const link = { color: '#a8c0ff', textDecoration: 'none', margin: '0 0.5rem' };

export default Footer;